<template>
    <div v-for="page in pages" class="col-4 mb-4 crsr-p" @click="openPage($event, page.number)">
      <img :alt="page.number" class="img-fluid op-hvr" v-bind:class="{ 'op': page.id !== currentPageId }"
           v-bind:src="'/umbraco/mdpaper/page/GetJpg?recordId=' + recordId + '&pageId=' +page.id"/> <span
        class="pt-2 small" v-bind:class="{ 'font-weight-bold': page.id === currentPageId }">
            {{ translations.page }} {{ page.number }}
        </span>
    </div>
</template>

<script>
export default {
  emits:["pageSelected"],
  props: {
    isMobile: Boolean,
    pages: Array,
    currentPageId: String
  },
  computed: {
    translations() {
      return multiPaper.translations;
    },
    recordId() {
      return this.$store.state.recordId;
    }
  },
  methods: {
    openPage(e, pageNumber) {
      const event = {
        e: e,
        pageNumber: pageNumber,
        toggle: !this.isMobile
      };
      this.$emit('pageSelected', event);
    }
  }
}
</script>